import { PerformerConstants } from '../../../constants/performer.constants';
import { ConsentIDs } from '../../../constants/service.constants';
import { ContextService } from '../../product/context';
import { EnrollmentContextService } from '../enrollment-context';
import { contactMapper } from './contact';
export const patientMapper = (
	context: ContextService,
	enrollmentContext: EnrollmentContextService
) => {
	let extension = undefined;
	const bttc = enrollmentContext.getFormField('bestTimeToConnect')?.value;
	if (bttc && enrollmentContext.input.consents.includes(ConsentIDs.tcpa)) {
		extension = [];
		extension.push({
			id: 'BestTimeToContact',
			url: 'BestTimeToContact',
			valueTiming: { when: [bttc] },
		});
	}

	const patient = {
		extension: extension,
		...contactMapper(context, enrollmentContext),
	};
	if (
		context.json.getForm('caregiverDetails') &&
		enrollmentContext.input.performer === PerformerConstants.caregiver
	) {
		patient.contact = {
			...contactMapper(
				context,
				enrollmentContext,
				PerformerConstants.caregiver
			),
			extension,
			relationship: [
				{
					coding: [
						{
							system: 'http://hl7.org/fhir/patient-contact-relationship',
							code: 'caregiver',
							display: 'Caregiver',
						},
					],
					text: 'Caregiver',
				},
			],
		};
	}
	return patient;
};
